import { makeStyles } from 'tss-react/mui'

export const useToolTipStyles = makeStyles()(() => ({
  customHeaderItems: {
    width: '100%',
    display: 'flex',
    minWidth: '30px',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  customHeaderLabel: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  tooltip: {
    backgroundColor: '#56585A',
    padding: '8px 4px',
    maxWidth: '300px !important',
  },
  expandCollapseHeader: {
    marginLeft: '30px',
  },
  arrow: {
    color: '#56585A',
  },
  fullName: {
    marginBottom: '8px !important',
  },
  definition: {
    whiteSpace: 'pre-wrap',
    marginBottom: '8px !important',
  },
  source: {
    whiteSpace: 'pre-wrap',
  },
  columnHdrIcnTooltip: {
    fontSize: 'large',
    marginLeft: '6px',
  },
}))
